import { render, staticRenderFns } from "./homePartner.vue?vue&type=template&id=497e10f6&scoped=true"
import script from "./homePartner.vue?vue&type=script&lang=js"
export * from "./homePartner.vue?vue&type=script&lang=js"
import style0 from "./homePartner.vue?vue&type=style&index=0&id=497e10f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497e10f6",
  null
  
)

export default component.exports